export enum TagType {
	Ongoing = 'Ongoing',
	Notifications = 'Notification',
	BrandLoops = 'BrandLoops',
	Product = 'Product',
}
